import GetLabel from 'foundation/js/getLabel'

export default {
    name: "FeaturedPostSpotCard",
    props: {
        spotCardData: {
            type: Object,
            required: true
        }
    },
    setup(){

        return {
            getLabel: (labelKey) => GetLabel({ labelKey, labelCollection: 'FeaturedPostSpotCard' })
        }
        
    }
}